import React from "react"
import { useTranslation } from "react-i18next"

import { ButtonLink } from "~/components/Button/Button"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Theme } from "~/components/Theme/Theme"
import { Wrapper } from "~/components/Wrapper/Wrapper"

import styles from "./index.module.css"

export const Cooperation: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div id="offer">
      <Theme theme="dark">
        <Wrapper>
          <div className="container">
            <div className={styles.Wrapper}>
              <div className={styles.TitleWrapper}>
                <Heading as="h2" className={styles.Title} like="h1">
                  <Raw html={t("procurements.Cooperation.Title")} />
                </Heading>
              </div>
              <div className={styles.DescriptionWrapper}>
                <Heading className={styles.Description} like="h3">
                  <Raw html={t("procurements.Cooperation.Description")} />
                </Heading>
                <div>
                  <Raw html={t("procurements.Cooperation.Text")} />
                </div>
              </div>

              <div className={styles.ButtonWrapper}>
                <ButtonLink
                  className={styles.Button}
                  href="/procurements/submit-application"
                  view="xl"
                >
                  <Raw html={t("procurements.Cooperation.Button")} />
                </ButtonLink>
              </div>
            </div>
          </div>
        </Wrapper>
      </Theme>
    </div>
  )
}
